import { render } from "./DetailAddGroupButton.vue?vue&type=template&id=4bb3ac98&scoped=true"
import script from "./DetailAddGroupButton.vue?vue&type=script&lang=js"
export * from "./DetailAddGroupButton.vue?vue&type=script&lang=js"

import "./DetailAddGroupButton.vue?vue&type=style&index=0&id=4bb3ac98&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb3ac98"]])

export default __exports__